import { render } from "./CompanyFollowUpRecordDetail.vue?vue&type=template&id=6746119d&scoped=true&ts=true"
import script from "./CompanyFollowUpRecordDetail.vue?vue&type=script&lang=ts"
export * from "./CompanyFollowUpRecordDetail.vue?vue&type=script&lang=ts"

import "./CompanyFollowUpRecordDetail.vue?vue&type=style&index=0&id=6746119d&lang=sass&scoped=true"
import "./CompanyFollowUpRecordDetail.vue?vue&type=style&index=1&id=6746119d&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6746119d"]])

export default __exports__